// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3c77468e","239":"67ccc8c2","455":"d5c8e7ca"}[chunkId] + ".chunk.js";
};